import { useMemo, useState, useRef, useContext } from "react"
import { UserContext } from "../../store/store"

import { limits } from "../../services/statics"
import useFetch from "../../hooks/useFetch"
import { api } from "../../services/api"
import { getCookie } from "../../helpers/cookies"

import { useQuery } from "../../hooks/useQuery"
import { Paginator } from "../../components/ui/Paginator"

import { config } from "../../config"
import { AsyncButton } from "../../components/ui/AsyncButton"
import { ModalCompartir } from "../../components/admin/ModalCompartir"
import { useTranslation } from "react-i18next"
import toast from "react-hot-toast"
import { ModalQA } from "../../components/admin/ModalQA"
import { kebabify } from "../../helpers/utils"
import { ModalEliminarQA } from "../../components/admin/ModalEliminarQA"

export const AgregarPyR = ({ setMenu }) => {
  // elements
  const form = useRef()

  // state
  const [showModal, setShowModal] = useState(false),
    [data, setData] = useState(false)

  const cleanForm = () => {
    form.current.reset()
    setMenu(kebabify(t(`admin.menu.qa.manage`)))
  }

  // ajax
  const query = useQuery()

  const onSubmitForm = async (e) => {
    e.preventDefault()

    const ta = form.current.querySelectorAll("textarea")[0],
      text = ta.value

    const { url, opt } = api.qa.generate({
      token: getCookie("jwt"),
      text,
    })

    query.url.current = url
    query.opt.current = opt

    query.run({
      onOk: (res) => {
        setData({
          text,
          title: "",
          questions: res,
        })
        setShowModal(true)
        // cleanForm()
      },
      onErr: (err) => {
        console.error(err)
        toast.error(t(`ui.msgs.something_went_wrong`))
      },
    })
  }

  const { t } = useTranslation()

  return (
    <>
      {showModal && (
        <ModalQA
          show={[showModal, setShowModal]}
          data={data}
          cleanForm={cleanForm}
        />
      )}

      <div className="col-lg-10 col-12" style={{ margin: "0 auto" }}>
        <div className="col-lg-10 col-12" style={{ margin: "0 auto" }}>
          <form ref={form}>
            <fieldset>
              <legend>{t(`admin.qa.gen_qa_set`)}</legend>

              <div className="form-group">
                <label className="form-label mt-4">{t(`admin.qa.text`)}</label>
                <textarea
                  disabled={query.isPending}
                  style={{ minHeight: "300px" }}
                  placeholder={t(`admin.qa.text_placeholder`)}
                  className="form-control"
                ></textarea>
              </div>

              <br />

              <AsyncButton
                onClick={onSubmitForm.bind(this)}
                disabled={query.isPending}
                sending={query.isPending}
              />
            </fieldset>
          </form>
        </div>
      </div>
    </>
  )
}

const ModalEditarQA = ({ show, id }) => {
  const { url, opt } = useMemo(() => api.qa.readOne({ id }), [id]),
    [data, isPending, err] = useFetch({ url, opt })

  if (isPending) return JSON.stringify("pending...")

  if (!isPending && err) return JSON.stringify(err)

  return <ModalQA show={show} data={data} cleanForm={() => {}} />
}

export const GestionarPyR = () => {
  const { t } = useTranslation()

  // state
  const [limit, setLimit] = useState(config.default_limit),
    [offest, setOffset] = useState(1),
    [matching, setMatching] = useState("")

  const [selected, setSelected] = useState(null),
    modalEliminar = useState(false),
    modalEditar = useState(false),
    modalCompartir = useState(false),
    [link, setLink] = useState(null)

  const onClickEditar = (entry) => {
    modalEditar[1](true)
    setSelected(entry)
  }

  const make_url = (qa) => `${config.base}/qa/${qa.id}`

  const onClickCopy = (qa) => {
    setLink(make_url(qa))
    modalCompartir[1](true)
  }

  const onClickEliminar = (entry) => {
    setSelected(entry)
    modalEliminar[1](true)
  }

  const { url, opt } = useMemo(
    () =>
      api.qa.readAll({
        from: offest,
        limit,
        match: matching,
      }),
    [limit, offest, matching]
  )
  const [data, isPending, err, setData] = useFetch({ url, opt })

  const ListConsignas = (qas) => {
    const [state] = useContext(UserContext)
    const theme = state.theme === "light" ? "table-striped" : "table-dark"

    return (
      <table className={"table table-hover w-100 " + theme}>
        <thead>
          <tr>
            <th>{t(`ui.tables.title`)}</th>
            <th>{t(`ui.tables.author`)}</th>
            <th>{t(`ui.tables.date`)}</th>
            <th>
              <center>{t(`ui.tables.share`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.edit`)}</center>
            </th>
            <th>
              <center>{t(`ui.tables.delete`)}</center>
            </th>
          </tr>
        </thead>
        <tbody style={{ borderTop: "2px solid #4e4e4e" }}>
          {qas.map((qa, ix) => (
            <tr key={ix}>
              <td>
                <a href={`qa/${qa.id}`} target="_blank" rel="noreferrer">
                  {qa.title}
                </a>
              </td>
              <td>
                <i>{qa.author.username}</i>
              </td>
              <td>
                <small>{qa.timestamp.substring(0, 10)}</small>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickCopy.bind(this, qa)}
                    className="btn btn-sm tooltip copy-tooltip"
                  >
                    📋
                  </button>
                </center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={onClickEditar.bind(this, qa)}
                    className="btn btn-sm tooltip edit-tooltip"
                  >
                    ✏️
                  </button>
                </center>
              </td>
              <td>
                <center>
                  <button
                    type="button"
                    onClick={() => onClickEliminar(qa)}
                    className="btn btn-sm tooltip elim-tooltip"
                  >
                    ❌
                  </button>
                </center>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }

  return (
    <>
      {modalEditar[0] && <ModalEditarQA show={modalEditar} id={selected.id} />}

      {modalEliminar[0] && (
        <ModalEliminarQA
          show={modalEliminar}
          entry={selected}
          setEntries={setData}
        />
      )}

      {modalCompartir[0] && (
        <ModalCompartir show={modalCompartir} link={link} />
      )}

      <div className="col-12" style={{ margin: "0 auto" }}>
        <h4>{t(`admin.menu.exercises.manage`)}</h4>

        <div className="d-flex justify-content-end align-items-center flex-row pb-3">
          <div className="form-check">
            <label className="form-check-label">
              {t(`ui.tables.limit`)}
              <select
                className="form-select mini-select mx-2"
                value={limit}
                onChange={(e) => setLimit(parseInt(e.target.value))}
                style={{ fontSize: "14px" }}
              >
                {limits.map((lim, ix) => (
                  <option key={ix} value={lim}>
                    {lim}
                  </option>
                ))}
              </select>
            </label>
          </div>

          <div className="form-check">
            <label className="form-check-label">
              <input
                className="form-control form-control-sm"
                style={{ width: "10vw" }}
                type="text"
                onChange={(e) => setMatching(e.target.value)}
                placeholder={t(`ui.tables.filter`)}
              />
            </label>
          </div>
        </div>

        {isPending && <p className="my-3">{t(`ui.btns.loading`)}...</p>}
        {err && <p className="my-3">{t(`ui.msgs.something_went_wrong`)}</p>}
        {!isPending && data && ListConsignas(data.entries)}

        {!isPending && !err && (
          <Paginator
            total={data.total}
            offset={offest}
            radius={9}
            setOffset={setOffset}
            pageSize={limit}
          />
        )}
      </div>
    </>
  )
}
